"use strict";
require('../../layouts/web')
require("../../../plugins/jssocials/jssocials");

$(document).ready(function() {
    $('.blog-recent-post').owlCarousel({
        loop: false,
        margin: 20,
        items: 1,
        dots: false,
        autoplay: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 3,
            }
        }
    })

    $('#toggleButton, #closeButton').click(function() {
        if (this.id === 'toggleButton') {
            $('#commentTypingArea').toggleClass('commentTypingAreaAnimation');
        } else if (this.id === 'closeButton') {
            $('#commentTypingArea').removeClass('commentTypingAreaAnimation');
        }
    });
})